import { VENUE_TYPES } from './constants';
import { FormSection } from '../../components/ui/FormSection';
import { AiGeneratedBadge } from '../../components/ui/AiGeneratedBadge';
import type { VenueType } from './constants';

interface BasicInformationSectionProps {
  name: string;
  onNameChange: (value: string) => void;
  venueType: VenueType;
  onVenueTypeChange: (value: VenueType) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
  descriptionSource: string | null;
}

export const BasicInformationSection = ({
  name,
  onNameChange,
  venueType,
  onVenueTypeChange,
  description,
  onDescriptionChange,
  descriptionSource,
}: BasicInformationSectionProps) => (
  <FormSection title="Basic Information">
    <div>
      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
        Name *
      </label>
      <input
        type="text"
        id="name"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        required
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>

    <div>
      <label htmlFor="venueType" className="block text-sm font-medium text-gray-700 mb-1">
        Venue Type *
      </label>
      <select
        id="venueType"
        value={venueType}
        onChange={(e) => onVenueTypeChange(e.target.value as VenueType)}
        required
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      >
        {VENUE_TYPES.map((type) => (
          <option key={type} value={type}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </option>
        ))}
      </select>
    </div>

    <div>
      <div className="flex items-center gap-2 mb-1">
        <label htmlFor="description" className="block text-sm font-medium text-gray-700">
          Description
        </label>
        {descriptionSource === 'ai_generated' && (
          <AiGeneratedBadge title="This description was generated or rewritten by AI. Edit and save to mark as manually verified." />
        )}
      </div>
      <textarea
        id="description"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        rows={4}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>
  </FormSection>
);
